<div *ngIf="state === 'ready'">
    <div class="row">
        <div class="col-11">
            Filter
            <input type="text" (input)="filterOrganizations($event)" />
        </div>
        <div class="col-1">

        </div>
    </div>
    <hr />

    <div *ngIf="state === 'ready'" class="tcc-table-div">
        <tcc-table tableClass="table-sm small" 
            [rows]="filteredOrgs" 
            [columns]="columns" 
            [buttons]="buttons"
            (cellClick)="rowClicked($event)">
        </tcc-table>
    </div>
</div>
<tcc-loadingOverlay *ngIf="state !== 'ready'"></tcc-loadingOverlay>